module.exports = __webpack_public_path__ + "static/media/linear.6497c936.svg";